import * as React from "react";

const SvgGraduation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 700 700"
    style={{
      enableBackground: "new 0 0 700 700",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path d="M657.5 285.2 358.6 391.6c-4.2 1.4-8.4 1.4-11.9 0L47.1 285.2c-16.1-5.6-16.1-28 0-33.6L346 144.5c4.2-1.4 8.4-1.4 11.9 0l299.6 107.1c15.3 5.6 15.3 28 0 33.6zM635.8 407v-76.3l-35.7 12.6v65.1c-7 5.6-11.9 14.7-11.9 24.5 0 17.5 14 30.8 30.8 30.8s30.8-14 30.8-30.8c0-11.2-5.6-21-14-25.9zm-283.5 21.7c-6.3 0-12.6-.7-18.2-2.8l-192.5-68.6v149.1c125.3 91 295.4 91 420.6 0V356.6l-191.8 68.6c-6.2 2.1-11.8 3.5-18.1 3.5z" />
  </svg>
);

export default SvgGraduation;
